import React from "react";
import IconButton from "./IconButton";
import { AudioIcon, VideoIcon, PlayIcon } from "./icons";

/*
 * Metadata-rich list row (showcase §09): media-type icon, series chip +
 * structured title (Body Large, 18px minimum), meta line, action button.
 * Long archival titles wrap (overflow-wrap:anywhere) — never truncate.
 */

export default function ListRow({
  mediaType = "audio", // 'audio' | 'video'
  indicator, // node — replaces the default media icon tile (e.g. MediaIndicator)
  chip, // node — series chip (Badge)
  title,
  meta, // node — the 14px meta line
  actionVariant = "circleOutline", // 'solid' (resume) | 'circleOutline' (play)
  actionLabel = "Play class",
  onAction,
  actions, // node — like/bookmark etc., joins the trailing controls (v1.1 §13)
  last = false,
  className = "",
}) {
  return (
    <div
      className={`flex items-center gap-4 px-6 py-4 ${last ? "" : "border-b border-ic-lightGray"} transition-colors duration-150 ease-out hover:bg-ic-offwhite ${className}`}
    >
      {indicator || (
        <span
          aria-label={mediaType === "video" ? "Video" : "Audio"}
          className="flex-shrink-0 w-11 h-11 border border-ic-borderGray rounded-2xl inline-flex items-center justify-center text-ic-body"
        >
          {mediaType === "video" ? <VideoIcon size={24} /> : <AudioIcon size={24} />}
        </span>
      )}
      <div className="flex-1 min-w-0 flex flex-col gap-1">
        <div className="flex items-center gap-3 flex-wrap">
          {chip && <span className="flex-shrink-0">{chip}</span>}
          <span className="text-[18px] leading-7 font-semibold text-black ic-wrap-anywhere">{title}</span>
        </div>
        {meta && <span className="text-[14px] leading-5 text-ic-slate">{meta}</span>}
      </div>
      {actions}
      <IconButton variant={actionVariant} size={48} label={actionLabel} onClick={onAction}>
        <PlayIcon size={20} />
      </IconButton>
    </div>
  );
}
